export default "__VITE_ASSET__Ctg$VVfm__"